import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

// Components
import { Link } from 'react-router-dom';
import Input from '../form/Input';

// Misc
import * as v from '../../modules/validators';

import styles from '../../../stylesheets/public/components/Forms.module.postcss';

function LoginForm({ handleSubmit, valid, submitting }) {
  return (
    <form
      className={styles.FlexForm}
      onSubmit={handleSubmit}
    >
      <div className='Fieldset'>
        <Field
          label='Email'
          name='email'
          component={Input}
          type='email'
          autoComplete='email'
          validate={[v.required, v.email]}
        />

        <Field
          label='Password'
          name='password'
          component={Input}
          type='password'
          autoComplete='current-password'
          validate={[v.required]}
        />

        <div className='FormRow'>
          <button
            className='Button u-w100 u-mt1'
            type='submit'
            disabled={!valid || submitting}
          >
            <span className='u-w100 u-textCenter'>Log In</span>
          </button>
          <div className='u-mt1 u-text-sm u-blockCenter u-textCenter'>
            <Link to='/forgot-password'>Forgot your password?</Link>
          </div>
        </div>
      </div>
    </form>
  );
}

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  valid: PropTypes.bool,
  submitting: PropTypes.bool
};

export default reduxForm({ form: 'login' })(LoginForm);
